import React from 'react';
import ReactGA from 'react-ga';
const GA_TRACKING_ID = 'UA-122959704-1';

export const init = () => {
  if (!window.GA_INITIALIZED) {
    ReactGA.initialize(GA_TRACKING_ID);
    window.GA_INITIALIZED = true;
  }
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.pageview(window.location.pathname);
};

export const initAndLogPageView = () => {
  init();
  logPageView();
};

export const logEvent = (category = '', action = '') => {
  if (category && action) {
    ReactGA.event({ category, action });
  }
};

export const logException = (description = '', fatal = false) => {
  if (description) {
    ReactGA.exception({ description, fatal });
  }
};

export class PageView extends React.Component {
  componentDidMount() {
    init();
    logPageView();
  }
  render() {
    return this.props.children || '';
  }
}
